// extracted by mini-css-extract-plugin
export default {"img":"Container3Box_img__21T7V"};